export default {
      id: "refeer__malanka-usage",
      viewBox: "0 0 24 40",
      url: __webpack_public_path__ + "img/icons.svg#refeer__malanka",
      toString: function () {
        return this.url;
      }
    }